export const renderLink = (
  code: string,
  url?: string | null,
): string | undefined => {
  if (url) {
    return url;
  }
  // return `https://club.craftginclub.co.uk/pages/sign-up?discount_code=${code}`;
};
